export enum MeasureConfigAverageType {
  RollupAverage = '0',
  TotalAverage = '1',
  BothTotalAndRollupAverage = '2'
}
